import { render } from "./Battle.vue?vue&type=template&id=44889d26&scoped=true"
import script from "./Battle.vue?vue&type=script&lang=js"
export * from "./Battle.vue?vue&type=script&lang=js"

import "./Battle.vue?vue&type=style&index=0&id=44889d26&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44889d26"]])

export default __exports__